module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "video-items"
  }, [_c('div', {
    staticClass: "active-item-title"
  }, [_vm._v("首届中国啦啦操文化节视频直播")]), _vm._v(" "), _c('div', {
    staticClass: "video-box"
  }, [_c('img', {
    staticClass: "play-img",
    attrs: {
      "src": require("../../assets/images/activity/pic-logo1@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "on-play",
    attrs: {
      "src": require("../../assets/images/activity/icon-video-play@2x.png"),
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "video-bottom"
  }, [_c('span', [_vm._v("2019总决赛")]), _vm._v(" "), _c('span', [_vm._v("235432人阅读")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ed879a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/NewsItem3.vue
// module id = 1478
// module chunks = 0